import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdReportsRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-reports',
	path: '/projects/:projectKey/reports/:reportType',
};
